<template>
  <div class="submission-census">
    <div class="search dark">
      <i class="smd-icon-action-search"></i>
      <input type="text"
             placeholder="Search Submission ID"
             id="searchText"
             v-model="searchText"/>
    </div>
    <div class="submission-cases__pagination" v-if="hasCensusPackage">
      <smd-btn clean class="icon-text" @click="back" :disabled="pagesProp.offset === 0 ">
        <i class="smd-icon-arrow-left"/>
        <label dark-normal>Back</label>
      </smd-btn>
      <p>
        {{pagesProp.offset + 1}} of {{pagesProp.count}}
      </p>
      <smd-btn clean class="icon-text" @click="next" :disabled="pagesProp.offset + 1 === pagesProp.count">
        <label dark-normal style="margin-right:10px">Next</label>
        <i class="smd-icon-arrow-right"/>
      </smd-btn>
    </div>
    <div class="pogs-list--panels__header">
      <label>Submission ID</label>
      <label>Census Package</label>
      <label>Status</label>
    </div>

    <div class="pogs-list--panels compact">
      <div class="pogs-list__item"
           v-for="(censusPackage, index) in censusPackages"
           :key="censusPackage._id"
           @click="openCensusPackage(censusPackage._id)">
        <div>
          {{ censusPackage._id }}
        </div>

        <div class="text-center">
          <strong>{{censusPackage.startDate | formatDate}} - {{censusPackage.endDate | formatDate}}
            ( {{censusPackage.numOfCases}}  Cases - v{{censusPackage.version}})
          </strong>
        </div>
        <div class="text-center">
          {{ censusPackage.status | allCaps }}
        </div>

        <div class="flex-row-center-x" :style="buttonVisibility(censusPackage, index)">
          <smd-btn @click.stop="rebuildPackage(censusPackage._id, censusPackage.fileName)" icon="smd-icon-menu-settings">
          </smd-btn>
          <smd-btn @click.stop="downloadCensus(censusPackage.fileName)" icon="smd-icon-action-download">
          </smd-btn>
          <smd-btn @click.stop="submitPackage(censusPackage._id, index)" icon="smd-icon-action-send">
          </smd-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import vue from 'vue'
  import {mapGetters} from 'vuex'
  import {fromEvent} from 'rxjs'
  import {debounceTime, distinctUntilChanged} from 'rxjs/operators'
  import {
    ACTION_LOAD_ALL_CENSUS_PACKAGES,
    ACTION_SEARCH_CENSUS_PACKAGE,
    ACTION_REBUILD_CENSUS_PACKAGE,
    GETTER_ALL_CENSUS_PACKAGES,
    ACTION_SUBMIT_CENSUS_PACKAGE,
    MUTATE_SET_PACKAGE_STATUS, GETTER_PACKAGES_PAGES
  } from '../../../../store/modules/submissions'

  import Routes from '../../../../router/route-constants'


  export default {
    name: "pogs-submissions__census",
    data() {
      return ({
        searchText: ""
      });
    },
    computed: {
      ...mapGetters({
        censusPackages: GETTER_ALL_CENSUS_PACKAGES,
        pagesProp: GETTER_PACKAGES_PAGES
      }),
      hasCensusPackage() {
        return !!Object.keys(this.censusPackages).length
      }
    },
    statusOptions: [
      { val: 'pending'  , label: 'Pending'},
      { val: 'submitted', label: 'Submitted'}
    ],
    methods: {
      next() {
        if (this.pagesProp.offset + 1 !== this.pagesProp.count) {
          this.$store.dispatch(ACTION_LOAD_ALL_CENSUS_PACKAGES, {offset: this.pagesProp.offset + 1});
        }
      },
      back() {
        if (this.pagesProp.offset !== 0) {
          this.$store.dispatch(ACTION_LOAD_ALL_CENSUS_PACKAGES, {offset: this.pagesProp.offset - 1});
        }
      },
      buttonVisibility(censusPackage) {
        return {visibility: censusPackage.status === "Sending" ? "hidden" : "visible"};
      },
      downloadCensus(id){
        window.open(
          '/api/submissions/download/' + id,
          '_blank' // <- This is what makes it open in a new window.
        );
      },
      openCensusPackage(submissionid){
        this.$router.push({
          name: Routes.ROUTE_OPEN_CENSUS_PACKAGE,
          params: {submissionid}
        })
      },
      rebuildPackage(submissionid, filename){
        this.$toasted.show("Building...");
        const params = {submissionid,filename};
        this.$store.dispatch(ACTION_REBUILD_CENSUS_PACKAGE, params)
          .then(message => {
            this.$toasted.show(message);
          })
          .catch(message => {
            this.$toasted.show('ERROR: ' +message.response.data.message);
          })
      },
      submitPackage(submissionid, index){
        if(this.censusPackages[index].status === "Sending") return;

        this.$toasted.show("Submitting...");
        this.$store.commit(MUTATE_SET_PACKAGE_STATUS, {index, value: "Sending"} );
        const params = {submissionid};
        this.$store.dispatch(ACTION_SUBMIT_CENSUS_PACKAGE, params)
          .then(uploaddata => {
            if (uploaddata.uploadid) {
              if (this.censusPackages[index]) {
                this.$store.commit(MUTATE_SET_PACKAGE_STATUS, {index, value: "Sent"} );
                this.$toasted.show("Successfully uploaded package");
              }
            }
          })
          .catch(message => {
            if (this.censusPackages[index]) {
              this.$store.commit(MUTATE_SET_PACKAGE_STATUS, {index, value: "Failed"} );
            }
            this.$toasted.show('ERROR: ' +message.response.data.message);
          })
      },
      filterSubmissions(id){
        const params = {id};
        this.$store.dispatch(ACTION_SEARCH_CENSUS_PACKAGE, params)
      },
    },
    mounted(){
      let searchText = document.getElementById("searchText");
      const onSearch = fromEvent(searchText,'input');
      onSearch.pipe(debounceTime(500), distinctUntilChanged())
        .subscribe((data) => {
          if (data.target.value !== "") {
            this.filterSubmissions(data.target.value);
          } else {
            this.$store.dispatch(ACTION_LOAD_ALL_CENSUS_PACKAGES);
          }
        });

      this.$store.dispatch(ACTION_LOAD_ALL_CENSUS_PACKAGES);
    }
  }
</script>

<style lang="scss">

  @import '../../../../scaffolding/scss/pogs-util';

  .submission-census{
    .pogs-list--panels__header,
    .pogs-list__item{
      display: grid !important;
      grid-template-columns: 215px 1fr 125px 100px ;
      grid-column-gap: space(m);

      & > *:first-child{
        justify-content: flex-start;
      }
      @include responsive(mobile) {
        grid-template-columns: 3fr auto auto;
        font-size: 12px;
      }
    }

    & > .pogs-list--panels.compact > .pogs-list__item{
      padding: space(s) space(base) !important;

      & > *:not(:first-child){
        justify-content: flex-end;
      }

      button[icon-o]{
        max-width: 36px;
        float: right;
      }
    }

    .smd-options{
      justify-content: flex-end;
      max-width: 180px;
      float: right;;
    }

    .pending{
      & > button[clean]{
        text-transform: none;
        color: color(label) !important;
        font-style: italic;

        span{
          font-style: normal;
        }
      }
    }
  }

</style>
